export interface IMembershipTypeDiscount {
  id: number;
  name?: string | null;
  amount?: number | null;
  membershipTypeId?: number | null;
}

export class MembershipTypeDiscount implements IMembershipTypeDiscount {
  id: number;
  name: string | null = null;
  amount: number | null = null;
  membershipTypeId: number | null = null;

  constructor(config: IMembershipTypeDiscount) {
    this.id = config.id;
    this.name = config.name ?? null;
    this.amount = config.amount ?? null;
    this.membershipTypeId = config.membershipTypeId ?? null;
  }
}
